<template>
  <MiniInfo__WP_Widget />

  <Header__WP_View />
  <Calendar__WP_View />
</template>

<script>
import Calendar__WP_View from "@/components/wp_planner/calendar.area.vue";
import Header__WP_View from "@/components/wp_planner/header.area.vue"
import MiniInfo__WP_Widget from "@/components/wp_planner/widgets/miniinfo.widget.vue";


export default {
  name: "MainArea__WP_View",
  components: { MiniInfo__WP_Widget, Calendar__WP_View, Header__WP_View }
}
</script>

<style scoped>
.info-block {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>

